import { render, staticRenderFns } from "./Demos.vue?vue&type=template&id=7168aa02&"
import script from "./Demos.vue?vue&type=script&lang=js&"
export * from "./Demos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports